/**
 * Capitalizes the first letter of the string
 * @param {String} str
 * @returns String
 */
export const capitalizeFirstLetter = (str) => {
  const lowerCaseString = str.toLowerCase();
  return lowerCaseString.charAt(0).toUpperCase() + lowerCaseString.substring(1);
};

/**
 * Transforms the provided string to title case.
 * @param {String} str The string to transform.
 * @returns String
 */
export function toTitleCase(str) {
  let strToTitleCase = '';

  if (str) {
    strToTitleCase = str
      .split(' ')
      .map((s) => capitalizeFirstLetter(s))
      .join(' ');
  }

  return strToTitleCase;
}

export const replaceHashWithUrlCode = (str) => {
  return str?.replace(/#/g, '%23');
};
